
import React from 'react';
import { useLoading } from '../../context/LoadingContext/LoadingContext'
import './LoadingOverlay.css'; // Asegúrate de crear este archivo CSS

const LoadingOverlay = ({ isLoading }) => {
  const { loading } = useLoading();

  if (!loading) return null;

  return (
    <div className="loading-overlay">
      <div className="spinner" />
      <p>Cargando...</p>
    </div>
  );
};

export default LoadingOverlay;
